import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Logo, LangToggle } from "@/components/Brand";
import { LEGAL } from "@/config/legal";
import { useApp } from "@/lib/i18n";

export default function Legal({ doc }) {
  const { lang, brand } = useApp();
  const text = LEGAL[doc][lang === "en" ? "en" : "ms"].replace(/\{(\w+)\}/g, (_, k) => brand[k] || "");
  return (
    <div className="min-h-screen bg-white" data-testid={`legal-${doc}`}>
      <header className="flex items-center justify-between border-b border-slate-200 px-6 py-4"><Logo /><LangToggle /></header>
      <main className="prose-minit mx-auto max-w-3xl px-6 py-12">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
        <p className="mt-8 text-xs text-slate-400" data-testid="legal-updated">{lang === "en" ? LEGAL[doc].updated_en : LEGAL[doc].updated}</p>
      </main>
    </div>
  );
}
